import { Component, input } from '@angular/core';
import { StatCardComponent } from '../stat-card/stat-card.component';
import { type StatCardItem } from './stat-card-list.model';

@Component({
  selector: 'lib-stat-card-list',
  imports: [StatCardComponent],
  templateUrl: './stat-card-list.component.html',
  styleUrl: './stat-card-list.component.css',
  host: { style: 'display: block' },
})
export class StatCardListComponent {
  readonly items = input.required<StatCardItem[]>();
}
